import { I18n } from 'react-redux-i18n';
import React from 'react';
import { MultiChipDropdown } from '../../components/V2ContextBar';

type ProductOption = { value: string; label: string };

interface ProductControlProps {
  options: ProductOption[];
  selected: ProductOption[];
  disabled: boolean;
  onChange: (products: ProductOption[]) => void;
}

// No "All"/"None" entry: at least one product is required to load data.
export const ProductControl: React.FC<ProductControlProps> = ({
  options,
  selected,
  disabled,
  onChange
}) => (
  <MultiChipDropdown
    options={options}
    selected={selected}
    onChange={onChange}
    placeholder={I18n.t('v2GlobalView.contextBar.productPlaceholder')}
    showAllOption={false}
    variant="brand"
    neutral
    disabled={disabled}
  />
);
